import * as APIStore from "../../store/APIStore";
import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import Typography from "@material-ui/core/Typography";

export interface DirectProps {
    message: APIStore.Message;
    subjectPatient: APIStore.Patient;
}


type NotificationPatientProps = APIStore.HNIContextState &
    typeof APIStore.actionCreators &
    DirectProps

const formatPcn = (pcnVal:string) => {
    if (!pcnVal) {
        return "N/A";
    }

    return pcnVal;
}
const NotificationPatient = (props: NotificationPatientProps) => {
    let patient: APIStore.Patient = props?.message.patient;
    if (!patient?.patientEncounterId) {
        patient = props?.FocusPatient.patient;
    }

    let { firstName, lastName, encounters, patientEncounterId } = patient;

    let subjectEncounter: APIStore.Encounter = encounters
        .filter(e => e.encounterId === patientEncounterId || e.patientId === patientEncounterId)[0];

    return (
        <Paper elevation={1} style={{ padding: 10 }}>
            <Grid container direction="row">
                <Grid item>
                    <Typography variant="subtitle2" component="div" gutterBottom>
                        Patient
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" component="div" gutterBottom>
                        {lastName}, {firstName}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" component="div" gutterBottom>
                        PCN {formatPcn(subjectEncounter.pcn)}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Policy No {formatPcn(subjectEncounter.mbi)}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" component="div" gutterBottom>
                        {subjectEncounter.facility.facilityName}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}




export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(NotificationPatient as any);